<nav class="navbar navbar-expand-md navbar-dark bg-info fixed-top ps-2 pe-1">
  <div class="navbar-brand">Camera Administration</div>
  <button
    class="navbar-toggler"
    type="button"
    (click)="toggleNav()"
    data-toggle="collapse"
    data-target="#adminNav"
  >
    <fa-icon [icon]="icons.bars"></fa-icon>
  </button>
  <div
    [ngbCollapse]="navCollapsed"
    class="collapse navbar-collapse"
    id="adminNav"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/"
          [class.disabled]="!adminService.isReady"
          ><fa-icon [icon]="icons.backArrow"></fa-icon> Back to Viewer</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          routerLink="sites"
          [class.disabled]="!adminService.isReady"
          (click)="closeNav()"
          >Sites</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          routerLink="users"
          [class.disabled]="!adminService.isReady"
          (click)="closeNav()"
          >Users</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          routerLink="alerts"
          [class.disabled]="!adminService.isReady"
          (click)="closeNav()"
        >
          Alerts
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLinkActive="active"
          routerLink="inventory"
          [class.disabled]="!adminService.isReady"
          (click)="closeNav()"
        >
          Inventory
        </a>
      </li>
    </ul>
    <ul class="navbar-nav ms-auto">
      <li class="nav-item">
        <button
          [disabled]="!adminService.isReady"
          (click)="refreshData()"
          title="Refresh Data"
          type="button"
          class="btn btn-sm btn-success btn-nav ms-1 text-white"
        >
          @if (this.adminService.isReady) {
            <fa-icon [icon]="icons.refresh"></fa-icon>
          }
          @if (!this.adminService.isReady) {
            <fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
          }
        </button>
      </li>
    </ul>
  </div>
</nav>
